import {SearchPageView} from './views/searchpageview.js';
import {PredictedResultsView} from './views/predictedresultsview.js';
import {SuggestedQueriesView} from './views/suggestedqueriesview.js';
import {RecentSearchesView} from './views/recentsearchesview.js';
import {SearchCategoriesController} from './views/searchcategoriescontroller.js';

export function createViewControl(store){
	var elements = store.getState().inputs.elements;

	function onWindowResize(event){
		store.dispatch({
			type: 'WINDOW_RESIZE'
		});
	}

	function onLoseFocus(event){
		var selector = `
			div.ekm-search-recent-searches,
			div.ekm-search-predicted-results,
			div.ekm-search-suggested-queries
		`;

		if (elements.includes(event.target)) return;
		if (event.target.closest(selector)) return;
		if (elements.includes(document.activeElement)) return;

		store.dispatch({
			type: 'INPUT_FOCUS_LOST'
		});
	}

	window.addEventListener('resize', onWindowResize);
	window.addEventListener('click', onLoseFocus);

	function onInputFocus(event){
		store.dispatch({
			type: 'INPUT_FOCUS',
			input: event.target
		});
	}

	function onInputInput(event){
		store.dispatch({
			type: 'INPUT_VALUE_CHANGE',
			value: event.target.value
		});
	}

	function onInputKeyDown(event){
		if (event.key === 'Enter'){
			var state = store.getState();
			if (state.isSearchPage || state.suggestions.activeQuery !== null){
				event.preventDefault();
			}
		}
	}

	function onInputKeyUp(event){
		if (event.key === 'Enter'){
			if (store.getState().suggestions.activeQuery !== null){
				store.dispatch({
					type: 'SELECT_ACTIVE_SUGGESTION'
				});
			}
			else {
				store.dispatch({
					type: 'SEARCH'
				});
			}
		}
		else if (event.key === 'ArrowUp'){
			store.dispatch({
				type: 'ACTIVE_SUGGESTION_UP'
			});
		}
		else if (event.key === 'ArrowDown'){
			store.dispatch({
				type: 'ACTIVE_SUGGESTION_DOWN'
			});
		}
	}

	function onFormSubmit(event){
		var input = [...event.target.elements].find(e => elements.includes(e));

		if (!input) return;

		store.dispatch({
			type: 'INPUT_FORM_SUBMIT',
			query: input.value
		});
	}

	elements.forEach(function(input){
		input.addEventListener('focus', onInputFocus);
		input.addEventListener('input', onInputInput);
		input.addEventListener('keydown', onInputKeyDown);
		input.addEventListener('keyup', onInputKeyUp);
	});

	// unique form elements that are parents of the input elements.
	var forms = elements
		.map(x => x.form)
		.filter((f, i, a) => f && i === a.indexOf(f));

	forms.forEach(form => {
		form.addEventListener('submit', onFormSubmit);
	});

	var suggestedQueriesView = new SuggestedQueriesView(store);
	var predictedResultsView = new PredictedResultsView(store);
	var recentSearchesView = new RecentSearchesView(store);
	var searchCategoriesController = new SearchCategoriesController(store);

	if (store.getState().isSearchPage){
		let element = document.getElementById('search-products');
		var searchPageView = new SearchPageView(store, element);
	}

	store.subscribe(function(state){
		var input = state.inputs.activeElement === null
			? null
			: state.inputs.elements[state.inputs.activeElement];

		var query = state.activeInputQuery;

		if (input && input.value !== query){
			input.value = query;
		}
	});
}